var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';


import {
  getCurrentPlan,
  getHubrecordPage,
  sendMigrationRequest as _sendMigrationRequest,
  testOneHub as _testOneHub,
  createRelationshipMigrationField,
  updateRelationshipMigrationField,
  deleteRelationshipMigrationField } from "../../Entities/actions/V2NewRelationshipsActions";

import { Icon } from "../../UI";
import { objectIndex } from "../../../shared/data_utils/objectIndex";








const UNUSED_RECORDS_PAGE_SIZE = 10;



































const mapPlanElementFromApiResponse = (
response,
templateIndex,
relationTypeIndex) =>
{
  const template = templateIndex[response.sourceTemplate];
  const relationType = relationTypeIndex[response.relationType];
  const targetTemplate = response.targetTemplate ?
  templateIndex[response.targetTemplate] :
  undefined;
  return {
    sourceTemplate: template.name,
    sourceTemplateId: response.sourceTemplate,
    relationType: relationType.name,
    relationTypeId: response.relationType,
    targetTemplate: (targetTemplate === null || targetTemplate === void 0 ? void 0 : targetTemplate.name) || 'ALL',
    targetTemplateId: response.targetTemplate,
    inferred: response.infered,
    ignored: response.ignored
  };
};

const mapGetPlanResponse = (
response,
templateIndex,
relationTypeIndex) =>
response.map((r) => mapPlanElementFromApiResponse(r, templateIndex, relationTypeIndex));

const formatTime = (time) => {
  const floored = Math.floor(time);
  if (floored < 1000) {
    return `${floored}ms`;
  }
  return `${(floored / 1000).toFixed(2)}s`;
};

class _NewRelMigrationDashboard extends React.Component {constructor(...args) {super(...args);_defineProperty(this, "migrationSummary", void 0);_defineProperty(this, "testedHub", void 0);_defineProperty(this, "hubTestResult", void 0);_defineProperty(this, "showMigrationConfirm",






    false);_defineProperty(this, "currentPlan",

    []);_defineProperty(this, "templateIndex",

    {});_defineProperty(this, "relationTypeIndex",

    {});_defineProperty(this, "templatesNameSorted",

    []);_defineProperty(this, "relationTypesNameSorted",

    []);_defineProperty(this, "newPlanElement",

    {
      sourceTemplate: '',
      sourceTemplateId: '',
      relationType: '',
      relationTypeId: '',
      targetTemplate: '',
      targetTemplateId: '',
      inferred: false,
      ignored: false
    });_defineProperty(this, "unusedConnectionsPage",

    1);_defineProperty(this, "unusedConnectionsInfo", void 0);}



  async componentDidMount() {
    this.templateIndex = objectIndex(
      this.props.templates,
      (t) => t._id,
      (t) => t
    );
    this.templatesNameSorted = _.orderBy(this.props.templates, (t) => t.name);
    this.relationTypeIndex = objectIndex(
      this.props.relationTypes,
      (t) => t._id,
      (t) => t
    );
    this.relationTypesNameSorted = _.orderBy(this.props.relationTypes, (t) => t.name);
    const response = await getCurrentPlan();
    const mapped = mapGetPlanResponse(response, this.templateIndex, this.relationTypeIndex);
    const ordered = _.orderBy(mapped, ['sourceTemplate', 'relationType', 'targetTemplate']);
    this.currentPlan = ordered;
    this.newPlanElement = {
      sourceTemplate: this.templatesNameSorted[0].name,
      sourceTemplateId: this.templatesNameSorted[0]._id,
      relationType: this.relationTypesNameSorted[0].name,
      relationTypeId: this.relationTypesNameSorted[0]._id,
      targetTemplate: this.templatesNameSorted[1].name,
      targetTemplateId: this.templatesNameSorted[1]._id
    };
    await this.getUnusedConnections();
    this.forceUpdate();
  }

  async getUnusedConnections(update = false) {
    this.unusedConnectionsInfo = await getHubrecordPage(
      this.unusedConnectionsPage,
      UNUSED_RECORDS_PAGE_SIZE
    );
    if (update) {
      this.forceUpdate();
    }
  }

  async sendMigrationRequest(dryRun) {
    const summary = await _sendMigrationRequest(dryRun, this.currentPlan);
    this.migrationSummary = summary;
    this.unusedConnectionsPage = 1;
    await this.getUnusedConnections();
  }

  async performDryRun() {
    await this.sendMigrationRequest(true);
    this.forceUpdate();
  }

  async performMigration() {
    await this.sendMigrationRequest(false);
    this.showMigrationConfirm = false;
    this.forceUpdate();
  }

  async storeTestedHub(event) {
    this.testedHub = event.target.value;
  }

  async testOneHub() {
    const testresult = await _testOneHub(this.testedHub, this.currentPlan);
    this.hubTestResult = testresult;
    this.forceUpdate();
  }

  readyMigration() {
    this.showMigrationConfirm = true;
    this.forceUpdate();
  }

  cancelMigration() {
    this.showMigrationConfirm = false;
    this.forceUpdate();
  }

  async toggleIgnore(pe) {
    pe.ignored = !pe.ignored;
    updateRelationshipMigrationField(pe).
    then(() => {
      this.forceUpdate();
    }).
    catch(() => {
      pe.ignored = !pe.ignored;
      this.forceUpdate();
    });
  }

  storeNewPlanElementSourceTemplate(event) {
    this.newPlanElement.sourceTemplateId = event.target.value;
    this.newPlanElement.sourceTemplate = this.templateIndex[event.target.value].name;
    this.forceUpdate();
  }

  storeNewPlanElementRelationType(event) {
    this.newPlanElement.relationTypeId = event.target.value;
    this.newPlanElement.relationType = this.relationTypeIndex[event.target.value].name;
    this.forceUpdate();
  }

  storeNewPlanElementTargetTemplate(event) {
    this.newPlanElement.targetTemplateId = event.target.value;
    this.newPlanElement.targetTemplate = this.templateIndex[event.target.value].name;
    this.forceUpdate();
  }

  async addNewPlanElement() {
    createRelationshipMigrationField(this.newPlanElement).then(
      (created) => {
        this.currentPlan.push(
          mapPlanElementFromApiResponse(created, this.templateIndex, this.relationTypeIndex)
        );
        this.forceUpdate();
      }
    );
  }

  async removePlanElement(index) {
    const pe = this.currentPlan[index];
    deleteRelationshipMigrationField(pe).then(() => {
      this.currentPlan.splice(index, 1);
      this.forceUpdate();
    });
  }

  renderUnusedConnections() {
    if (!this.unusedConnectionsInfo) {
      return /*#__PURE__*/_jsx("div", {});
    }
    const maxPage = Math.ceil(this.unusedConnectionsInfo.fullCount / UNUSED_RECORDS_PAGE_SIZE);
    return (
      this.unusedConnectionsInfo && /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        disabled: this.unusedConnectionsPage === 1,
        onClick: async () => {
          this.unusedConnectionsPage -= 1;
          await this.getUnusedConnections(true);
        } }, void 0,
      "\u2190"

      ), /*#__PURE__*/
      _jsx("span", {}, void 0,
      this.unusedConnectionsPage, "/", maxPage
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        disabled: this.unusedConnectionsPage === maxPage,
        onClick: async () => {
          this.unusedConnectionsPage += 1;
          await this.getUnusedConnections(true);
        } }, void 0,
      "\u2192"

      )
      ),
      this.unusedConnectionsInfo.hubRecords.map((records, index) => /*#__PURE__*/
      _jsx("div", {}, `UnusedConnectionList_${records.hubId}`, /*#__PURE__*/
      _jsx("div", {}, void 0,
      index + 1, "---------------------------:", records.hubId
      ),
      records.connections.map((connection) => /*#__PURE__*/
      _jsx("div", {}, `unusedConnection_${records.hubId}_${connection.id}`, "\u2003",

      `(${connection.templateName})`, /*#__PURE__*/
      _jsx(Icon, { icon: "link" }),
      `${connection.entityTitle}(${
      this.templateIndex[connection.entityTemplate].name})`

      )
      )
      )
      )
      ));


  }

  render() {var _this$hubTestResult, _this$hubTestResult2, _this$hubTestResult3;
    const oneHubTestEntityTitlesBySharedId = objectIndex(
      ((_this$hubTestResult = this.hubTestResult) === null || _this$hubTestResult === void 0 ? void 0 : _this$hubTestResult.original) || [],
      (t) => t.entity,
      (t) => t.entityTitle
    );
    const oneHubTestEntityTemplatesBySharedId = objectIndex(
      ((_this$hubTestResult2 = this.hubTestResult) === null || _this$hubTestResult2 === void 0 ? void 0 : _this$hubTestResult2.original) || [],
      (t) => t.entity,
      (t) => t.entityTemplate
    );
    const oneHubRelTypeNamesById = objectIndex(
      ((_this$hubTestResult3 = this.hubTestResult) === null || _this$hubTestResult3 === void 0 ? void 0 : _this$hubTestResult3.original) || [],
      (t) => t.template,
      (t) => t.templateName
    );
    const displayEntityTitleAndNameFromOriginal = (orig) =>
    `${oneHubTestEntityTitlesBySharedId[orig.entity]}(${
    this.templateIndex[orig.entityTemplate].name})`;

    const displayEntityTitleAndNameFromTransformed = (entity) =>
    `${oneHubTestEntityTitlesBySharedId[entity]}(${
    this.templateIndex[oneHubTestEntityTemplatesBySharedId[entity]].name})`;


    return (/*#__PURE__*/
      _jsx("div", { className: "settings-content", "no-translate": true }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel-heading" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, "Migration Dashboard")
      ), /*#__PURE__*/
      _jsx("div", { className: "panel-body" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn", onClick: this.performDryRun.bind(this) }, void 0, "Dry Run"

      ), "\u2003", /*#__PURE__*/

      _jsx("button", { type: "button", className: "btn", onClick: this.readyMigration.bind(this) }, void 0, "Migrate"

      ),
      this.showMigrationConfirm && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", {}, void 0, "This will clean all your existing v2 relationships. Are you sure?"), /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn", onClick: this.performMigration.bind(this) }, void 0, "Perform"

      ), /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn", onClick: this.cancelMigration.bind(this) }, void 0, "Cancel"

      )
      ), /*#__PURE__*/

      _jsx("br", {}), /*#__PURE__*/
      _jsx("br", {}),
      this.migrationSummary && /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx("div", {}, void 0, "Migration Summary", this.migrationSummary.dryRun ? ' (Dry Run)' : '', ":"), /*#__PURE__*/
      _jsx("div", {}, void 0, "Time: ", formatTime(this.migrationSummary.time)), /*#__PURE__*/
      _jsx("div", {}, void 0, "Total: ",
      this.migrationSummary.total,
      `(text references: ${this.migrationSummary.totalTextReferences})`
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, "Used: ",
      this.migrationSummary.used,
      `(${this.migrationSummary.usedTextReferences})`
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, "Unused: ",
      this.migrationSummary.total - this.migrationSummary.used,
      `(${
      this.migrationSummary.totalTextReferences -
      this.migrationSummary.usedTextReferences})`

      ), /*#__PURE__*/
      _jsx("div", {}, void 0, "Errors: ", this.migrationSummary.errors), /*#__PURE__*/
      _jsx("br", {})
      ), /*#__PURE__*/

      _jsx("br", {}), /*#__PURE__*/
      _jsx("div", {}, void 0, "Current migration plan:"),
      this.currentPlan.map((p, index) => /*#__PURE__*/
      _jsx("div", {}, `${p.sourceTemplate}_${p.relationType}_${p.targetTemplate}`,
      p.sourceTemplate, "\u2003", /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-right" }), "\u2003",

      `(${p.relationType})`, "\u2003", /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-right" }), "\u2003",

      p.targetTemplate, "\u2003 -- \u2003",

      [p.inferred ? 'inferred' : 'user defined', p.ignored ? 'ignored' : undefined].
      filter((x) => x).
      join(', '), "\u2003", /*#__PURE__*/

      _jsx("button", {
        type: "button",
        onClick: this.toggleIgnore.bind(this, p),
        className: `btn btn-xs${p.ignored ? ' btn-danger' : ' btn-success'} }` }, void 0,

      `${p.ignored ? 'Unignore' : 'Ignore'}`
      ),
      !p.inferred && /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.removePlanElement.bind(this, index),
        className: "btn btn-xs" }, void 0,
      "Remove"

      )

      )
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("select", {
        value: this.newPlanElement.sourceTemplateId,
        onChange: this.storeNewPlanElementSourceTemplate.bind(this) }, void 0,

      this.templatesNameSorted.map((t) => /*#__PURE__*/
      _jsx("option", { value: t._id }, `sourceDropdown_${t._id}`,
      t.name
      )
      )
      ), /*#__PURE__*/
      _jsx("select", {
        value: this.newPlanElement.relationTypeId,
        onChange: this.storeNewPlanElementRelationType.bind(this) }, void 0,

      this.relationTypesNameSorted.map((t) => /*#__PURE__*/
      _jsx("option", { value: t._id }, `relationDropdown_${t._id}`,
      t.name
      )
      )
      ), /*#__PURE__*/
      _jsx("select", {
        value: this.newPlanElement.targetTemplateId,
        onChange: this.storeNewPlanElementTargetTemplate.bind(this) }, void 0,

      this.templatesNameSorted.map((t) => /*#__PURE__*/
      _jsx("option", { value: t._id }, `targetDropdown_${t._id}`,
      t.name
      )
      )
      ), /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.addNewPlanElement.bind(this) }, void 0, "Add"

      )
      ), /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.testOneHub.bind(this) }, void 0, "Test One Hub"

      ), /*#__PURE__*/
      _jsx("input", { type: "text", onChange: this.storeTestedHub.bind(this) }),
      this.hubTestResult && /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, "Test Result:"), /*#__PURE__*/
      _jsx("div", {}, void 0, "Total: ", this.hubTestResult.total), /*#__PURE__*/
      _jsx("div", {}, void 0, "Used: ", this.hubTestResult.used), /*#__PURE__*/
      _jsx("div", {}, void 0, "Unused: ", this.hubTestResult.total - this.hubTestResult.used), /*#__PURE__*/
      _jsx("table", {}, void 0, /*#__PURE__*/
      _jsx("thead", {}, void 0, /*#__PURE__*/
      _jsx("tr", {}, void 0, /*#__PURE__*/
      _jsx("th", {}, void 0, "Original Hub"), /*#__PURE__*/
      _jsx("th", {}, void 0, "Transformed")
      )
      ), /*#__PURE__*/
      _jsx("tbody", {}, void 0, /*#__PURE__*/
      _jsx("tr", {}, void 0, /*#__PURE__*/
      _jsx("td", {}, void 0,
      this.hubTestResult.original.map((t) => /*#__PURE__*/
      _jsx("div", {}, `${t.template}_${t.entity}`,
      oneHubRelTypeNamesById[t.template], "\u2003", /*#__PURE__*/
      _jsx(Icon, { icon: "link" }), "\u2003",

      displayEntityTitleAndNameFromOriginal(t)
      )
      )
      ), /*#__PURE__*/
      _jsx("td", {}, void 0,
      this.hubTestResult.transformed.map((t) => /*#__PURE__*/
      _jsx("div", {}, `${t.from.entity}_${t.to.entity}_${t.type}`,
      displayEntityTitleAndNameFromTransformed(t.from.entity), "\u2003", /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-right" }), "\u2003",

      oneHubRelTypeNamesById[t.type], "\u2003", /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-right" }), "\u2003",

      displayEntityTitleAndNameFromTransformed(t.to.entity)
      )
      )
      )
      )
      )
      )
      ), /*#__PURE__*/

      _jsx("br", {}), /*#__PURE__*/
      _jsx("br", {}),
      this.renderUnusedConnections()
      )
      )
      ));

  }
}






const mapStateToProps = ({ templates, relationTypes }) => ({
  templates: templates.toJS(),
  relationTypes: relationTypes.toJS()
});

const NewRelMigrationDashboard = connect(mapStateToProps)(_NewRelMigrationDashboard);

export { NewRelMigrationDashboard };